import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_13108_21440)">
      <path
        d="M11.9414 2.49121C13.7871 3.80957 14.9883 5.96582 14.9883 8.40625C14.9883 12.4141 11.7422 15.6631 7.73731 15.6719C3.73829 15.6807 0.462896 12.4199 0.457037 8.41797C0.454107 5.97754 1.65528 3.81543 3.49805 2.49414C3.84083 2.25098 4.31837 2.35352 4.52344 2.71973L4.98633 3.54297C5.15919 3.85059 5.07715 4.24023 4.79297 4.45117C3.57715 5.35352 2.80079 6.7832 2.80079 8.40332C2.79786 11.1074 4.9834 13.3281 7.72266 13.3281C10.4063 13.3281 12.6621 11.1543 12.6445 8.37402C12.6357 6.85645 11.9209 5.3916 10.6494 4.44824C10.3652 4.2373 10.2861 3.84766 10.459 3.54297L10.9219 2.71973C11.127 2.35645 11.6016 2.24805 11.9414 2.49121ZM8.89454 8.64062V1.60938C8.89454 1.21973 8.58106 0.90625 8.19141 0.90625H7.25391C6.86426 0.90625 6.55079 1.21973 6.55079 1.60938V8.64062C6.55079 9.03027 6.86426 9.34375 7.25391 9.34375H8.19141C8.58106 9.34375 8.89454 9.03027 8.89454 8.64062Z"
        fill="#F30F27"
      />
    </g>
    <defs>
      <clipPath id="clip0_13108_21440">
        <rect
          width={15}
          height={15}
          fill="white"
          transform="translate(0.222656 0.90625)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
